import { Address, EndAddress, TaskList, TaskListGen } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"
import { TaskListStatus } from "@/types";


function modelMapper(inputTaskList: any): TaskList {
    const codeTournee = inputTaskList.codeTournee || "";
    const status = inputTaskList.taskListStatus || "";
    const initializeStartAddress = (address: any): Address => {
        if (!address) {
            return {
                rue: "",
                ville: "",
                numero: "",
                codepostale: ""
            };
        }
        return address;
    }
    const initializeEndAddress = (address: any): EndAddress => {
        if (!address) {
            return {
                street: "",
                city: "",
                number: "",
                postcode: ""
            };
        }
        return address;
    }
    return {
        id: inputTaskList.id,
        name: inputTaskList.name,
        codeTournee,
        dateDebut: inputTaskList.dateDebut,
        dateFin: inputTaskList.dateFin,
        technicienIds: inputTaskList.technicienIds,
        technicienNames: inputTaskList.technicienNames,
        taskListStatus: inputTaskList.taskListStatus,
        label: `${codeTournee} - ${status}`.trim(),
        startAddress: initializeStartAddress(inputTaskList.startAddress),
        endAddress: initializeEndAddress(inputTaskList.endAddress),
        vehicleId: inputTaskList.vehicleId
    };
}

export function modelMapperArray(inputArray: any[]): TaskList[] {
    return inputArray.map(modelMapper);
}

export async function getFilteredTaskLists(statuses?: TaskListStatus[], userId?: string, startDate?: Date): Promise<TaskList[]> {
    const params = new URLSearchParams();

    if (statuses && statuses.length > 0) {
        params.append("status", statuses.join(","));
    }

    if (userId) {
        params.append("user_id", userId);
    }

    if(startDate) {
        params.append("start_date", startDate.toISOString().split('T')[0]);
    }

    const query = params.toString();
    const url = query ? `/tasklists?${query}` : "/tasklists";

    const response = await getData<TaskList[]>(url);
    return modelMapperArray(response ?? []);
}

// Return the maintenance history for a laverie
export async function getTaskListsHistory(laverieId: string): Promise<TaskList[]> {
    const response = await getData<TaskList[]>("/tasklists/history/" + laverieId);
    return modelMapperArray(response ?? []);
}

export function getTaskListGenById(id: string): Promise<TaskListGen> {
    return getData<TaskListGen>("/tasklists/" + id + "/gen").then(
        onSucceed => {
            return onSucceed;
        }
    );
}

export function getTaskListById(id: string): Promise<TaskList> {
    return getData("/tasklists/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postTaskList(taskList: TaskList): Promise<TaskList> {
    return postData("/tasklists", taskList).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function assignTasksToList(
    taskListId: string,
    taskIds: string[]
): Promise<void> {
    return postData(`/tasklists/${taskListId}/assign-tasks`, { taskIds }).then(
        () => {
            return
        }
    )
}


export function putTaskList(id: string, taskList: TaskList): Promise<any> {
    return putData("/tasklists/" + id, taskList)
}

export function deleteTaskList(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("/tasklists/" + idsStr)
}

export async function searchForTaskLists(searchQuery: string): Promise<TaskList[]> {
    const response = await getData<TaskList[]>("/tasklists?" + searchQuery);
    return modelMapperArray(response ?? []);
}